import { FilestoreAPI } from '@builddocs/filestore-api'

export interface GetDocstoreCiphersRequest {
  section: string
  projectId: string
}

type GetDocstoreCiphersResponse = Array<string>

export function getDocstoreCiphers({
  section,
  projectId,
}: GetDocstoreCiphersRequest) {
  return FilestoreAPI.get<GetDocstoreCiphersResponse>(
    `/${section.toLowerCase()}/ciphers`,
    {
      params: { projectId },
    },
  ).then(r => r.data)
}
